import {
  Control,
  FieldValues,
  UseFormRegister,
  UseFormWatch,
} from "react-hook-form";

export enum FileClaimSteps {
  PURCHASE_DETAILS = "Purchase Details",
  CUSTOMER_DETAILS = "Customer Details",
  STORE_DETAILS = "Store Details",
  DAMAGE_DETAILS = "Damaged Items", 
  REVIEW_CLAIM_DETAILS = "Review claim details",
}

export const claimStepsData = [
  {
    step_num: 1,
    title: FileClaimSteps.PURCHASE_DETAILS,
  },
  {
    step_num: 2,
    title: FileClaimSteps.CUSTOMER_DETAILS,
  },
  {
    step_num: 3,
    title: FileClaimSteps.STORE_DETAILS,
  },
  {
    step_num: 4,
    title: FileClaimSteps.DAMAGE_DETAILS,
  },
  {
    step_num: 5,
    title: FileClaimSteps.REVIEW_CLAIM_DETAILS,
  },
  
];

export interface StepsProps<FieldsType extends FieldValues> {
  control: Control<FieldsType>;
  register: UseFormRegister<FieldsType>;
  watch: UseFormWatch<FieldsType>;
}
